export default __webpack_public_path__ + "static/3-f0066dd4ee53b2a6e8716db5dc4f9f93.png";